'use strict';

import 'unfetch/polyfill'

export default class RestController {

    constructor(rest_url)
    {
        this.base_url = `${rest_url}garage-services/v1`;
        this.partner_price_url = `${rest_url}partners/v1`;
        this.blocks_url = `${rest_url}repareo/v1`;

        this.services_url = '/services';
        this.service_url = '/service';
        this.brands_url = '/brands';
        this.generations_url = '/generations';
        this.types_url = '/types';
        this.type_url = '/type';
        this.kba_url = '/kba';


        this.cost_url = '/cost';
        this.table_url = '/garage-search/datatable';
    }

    async service(service)
    {
        if (typeof service === 'undefined') {
            return
        }
        let url = `${this.base_url}${this.service_url}/${service}/`;
        return this.get(url);
    }

    async brands()
    {
        let url = `${this.base_url}${this.brands_url}/`;
        return this.get(url);
    }

    async generations(brand)
    {
        if (typeof brand === 'undefined') {
            return
        }
        let url = `${this.base_url}${this.generations_url}/${brand}/`;
        return this.get(url);
    }

    async types(brand, generation)
    {
        if (typeof brand === 'undefined' || typeof generation === 'undefined') {
            return
        }
        let url = `${this.base_url}${this.types_url}/${brand}/${generation}/`;
        return this.get(url);
    }

    async type(brand, generation, type)
    {
        if (typeof brand === 'undefined' || typeof generation === 'undefined' || typeof type === 'undefined') {
            return
        }
        let url = `${this.base_url}${this.type_url}/${brand}/${generation}/${type}/`;
        return this.get(url);
    }

    async kba(kbaNumber)
    {
        if (typeof kbaNumber === 'undefined') {
            return
        }
        let url = `${this.base_url}${this.kba_url}/${kbaNumber}/`;
        return this.get(url);
    }

    async cost(service, type)
    {
        let url = `${this.base_url}${this.cost_url}/${service}/${type}/`;
        return this.get(url);
    }

    async table(service, brand, generation, type)
    {
        let url = `${this.base_url}${this.table_url}/${service}/${brand}/${generation}/${type}/`;
        return this.get(url);
    }

    async partnerPrice(slug, service, brand, generation, type, postalcode)
    {
        let url = `${this.partner_price_url}/${slug}/${service}/${brand}/${generation}/${type}/${postalcode}/`;
        return this.get(url);
    }

    async tableData(type, post, generation, offset)
    {
        let url = `${this.blocks_url}/cost-table/${post}/${generation}/${offset}/`;

        if (type === 'interval') {
            url = `${this.blocks_url}/interval-table/${post}/${generation}/${offset}/`;
        }

        return this.getHtml(url);
    }

    async inquiry(payload)
    {
        let url = `${this.blocks_url}/inquiry/`;

        return this.post(url, payload);
    }

    async post(url, data)
    {
        return fetch(
            url,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                return json;
            });
    }

    async get(url)
    {
        return fetch(url)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                return json;
            });
    }

    async getHtml(url)
    {
        return fetch(url)
            .then((response) => {
                return response.text();
            })
            .then((json) => {
                return json;
            });
    }
}
